// DEPENDENCIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// TODO: this shit is not maintained any more new - @react-google-maps/api but requries react > v16
import { withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps"; //GoogleMapLoader
import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer'
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

// COMPONENTS
import MoneySlider from './MoneySlider';
import PinToolTip from './PinToolTip';
// import CustomMarker from './CustomMarker';

// INNER IMPORTS
import mapStyle from '../../Config/mapStyle';
import { defaultLocation, clientMedia } from '../../Config/Settings';
import { LIVE_MUSIC, BAND, MUSICIAN, MAP_MARKER_HIGH_PAID_SIZE } from '../../consts';
import { PinFullViewModalWeb, PinFullViewModalMobile } from '../ModalsNew';

// actions
import * as actions from '../../Actions/main';
import { closePinFullViewModal, openPinFullViewModal } from '../../Actions/modals';

// utils
import { isMobile } from '../../utils';

// styles
import './MugicsMap.css';
import { ENROL_TYPE_HIGH, ENROL_TYPE_HUGE } from "../../Models/consts";
import PinCounterLabel from "../Elements/PinCounters/PinCounterLabel";
import {AnalyticsService, LocalStorageService} from "../../Services";

class MugicsMap extends Component {

    /****** COMPONENT LIFE-CYCLE FUNCTIONS ******/
    constructor(props) {
        super(props);
        // We wish to save what infoBox (pin ToolTip) is showing on the map
        this.state = {
            showInfoKey: '',
            isHoveringTooltip: false,
            isHoveringMarker: false,
            width: 30,
            height: 30,
            isPinToolOpen: false, // false,
            mapDefaults: defaultLocation,
            showSmallPins: false,
            smallPinsTimeoutSet: false,
            mapIsMounted: false
        };

        this.isPinsTimerHold = false;
        this.isMapMoving = false;

        this.mapArea = null;
        this.timer = null;
        // In order to be able to add this as a listener and remove it when the component is unmounted
        this.onScroll = this.onPageScroll.bind(this);

        this.MapComponent = withGoogleMap(mapProps => {
            const {
                maxClusterZoom,
                maxClusterZoomMobile,
                clusterDistance,
                clusterDistanceMobile
            } = this.props.datatypes.defaults || {};

            let cDistance = clusterDistance;
            let cMaxClusterZoom = maxClusterZoom;

            if (isMobile()) {
                cDistance = clusterDistanceMobile;
                cMaxClusterZoom = maxClusterZoomMobile;
            }

            return (
                <GoogleMap
                    ref={this.handleMapMounted.bind(this)}
                    defaultCenter={this.props.currentLocation}
                    defaultZoom={this.getDefaultZoom()}
                    options={this.mapOptions()}
                    onIdle={() => this.setMapBoundaries()}
                    onZoomChanged={() => this.handleZoomChange()}
                    onClick={() => this.setState({isPinToolOpen: false, isHoveringMarker: false, showInfoKey: ''})}
                >
                    <MarkerClusterer
                        zoomOnClick={false}
                        averageCenter
                        enableRetinaIcons
                        gridSize={cDistance}
                        maxZoom={cMaxClusterZoom}
                        // defaultImagePath={`${clientMedia()}/img/mapIcons/band-marker.svg`}
                        // imagePath={`${clientMedia()}/img/mapIcons/musician-marker.svg`}
                        clusterClass={`marker-cluster ${this.props.filters && this.props.filters.type}`}
                        onClick={mapClusterProps => {
                            mapClusterProps.map_.setZoom(this._map.getZoom() + 1)
                            setTimeout(() => {
                                if (!mapClusterProps || !mapClusterProps.center_) return;

                                this._map.panTo({lat: mapClusterProps.center_.lat(), lng: mapClusterProps.center_.lng()})
                            }, 1)
                        }}
                    >
                        {this.renderPins()}

                    </MarkerClusterer>
                    {/*{this.state.showSmallPins && !this.isPinsTimerHold ? this.renderPins() : null}*/}
                </GoogleMap>
            )
        })
    }

    componentDidMount() {
        document.addEventListener('scroll', this.onScroll);
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.onScroll);
    }

    componentWillUpdate() {
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps) return;

        if (!nextProps.currentLocation || !nextProps.currentLocation.lat || !nextProps.currentLocation.lng) {
            if (!this.mapArea) {
                // this.currentLocationSet = true;
                this.changeLocation(this.state.mapDefaults);
            }
        }

        // In case the currentLocation has changed (if the user entered a new location) - the map center should change accordingly
        if (nextProps.currentLocation && this.props.currentLocation) {
            if (nextProps.currentLocation.lat !== this.props.currentLocation.lat ||
                nextProps.currentLocation.lng !== this.props.currentLocation.lng) {
                this.changeLocation(nextProps.currentLocation);
            }
        }

        if (
            nextProps.datatypes &&
            nextProps.datatypes.defaults &&
            nextProps.groupedPins &&
            this.props.groupedPins &&
            Object.keys(nextProps.groupedPins).length !== Object.keys(this.props.groupedPins).length
        ) {
            // TODO: this is a shitty hack - but without a better solution it is what it is
            if (!nextProps.datatypes.defaults.bigSmallPinsDiff) {
                this.isPinsTimerHold = false;
                this.setState({showSmallPins: true, smallPinsTimeoutSet: false});
            }

            if (!this.state.smallPinsTimeoutSet && nextProps.datatypes.defaults.bigSmallPinsDiff) {
                this.setState({smallPinsTimeoutSet: true, showSmallProps: false});
                this.isPinsTimerHold = true;

                setTimeout(() => {
                    this.isPinsTimerHold = false;
                    this.setState({showSmallPins: true, smallPinsTimeoutSet: false});
                }, nextProps.datatypes.defaults.bigSmallPinsDiff * 1000);
            }
        }

        if (nextProps.datatypes && !this.props.datatypes) {
            this.setState({
                width: nextProps.datatypes.defaults.dotSizesByZoom[nextProps.datatypes.defaults.zoom - 1],
                height: nextProps.datatypes.defaults.dotSizesByZoom[nextProps.datatypes.defaults.zoom - 1]
            })
        }
    }

    changeLocation(newLocation) {
        if (this._map && newLocation.lat && newLocation.lng)  {
            this._map.panTo(newLocation);
        }
    }

    /****** MAP FUNCTIONS ******/
    onPageScroll() {

        var _this = this;
        if (this.state.scrollwheel === undefined) {
            this.setState({
                scrollwheel: true
            })

            return;
        }

        this.setState({ scrollwheel: false });

        if (this.timer !== null) clearTimeout(this.timer);

        this.timer = setTimeout(function() {
            _this.setState({
                scrollwheel: true
            })
        }, 500);
    }

    mapOptions() {
        return {
            mapTypeControl: false,
            streetViewControl: false,
            styles: mapStyle.styles,
            fullscreenControl: true,
            minZoom: 1,
            maxZoom: 20,
            clickableIcons: false,
            scrollwheel: this.state.scrollwheel
        }
    }

    getDefaultZoom() {
        if (isMobile()) return this.props.datatypes.defaults.mobileZoom;

        return this.props.datatypes.defaults.zoom;
    }

    // Saving map so we could use setCenter later
    handleMapMounted(map) {
        if (!map || this._map) return

        this._map = map;
        if (!this.state.mapIsMounted && this.props.currentLocation) {
            this.changeLocation(this.props.currentLocation);
        }

        this.setState({mapIsMounted: true});

        this.setNewMapPins();
    }


    // In order to avoid getting to the grey area of the map, we set north and south boundaries
    setMapBoundaries() {
        // var sLat = this._map.getBounds().getSouthWest().lat();
        // var nLat = this._map.getBounds().getNorthEast().lat();
        // var newLat;
        // if (sLat < -85) {
        //     newLat =  this._map.getCenter().lat() - (sLat+85);
        // }
        // if (nLat > 85) {
        //     newLat =  this._map.getCenter().lat() - (nLat-85);
        // }
        // if (newLat) {
        //     this._map.panTo({lat: newLat, lng: this._map.getCenter().lng()});
        // }

        this.setNewMapPins();
    }

    setNewMapPins() {
        if (!this._map) return;

        // if (this.isMapMoving) return;
        const mapBoundsAdd =  this._map.getZoom() < 9 ? 0.5 : 1.5;

        const mapBounds = this._map.getBounds();

        if (!mapBounds) return;

        const area = {
            top: this._map.getBounds().getNorthEast().lat() + mapBoundsAdd,
            bottom: this._map.getBounds().getSouthWest().lat() - mapBoundsAdd,
            right: this._map.getBounds().getNorthEast().lng() + mapBoundsAdd,
            left: this._map.getBounds().getSouthWest().lng() - mapBoundsAdd
        };

        this.isMapMoving = true;

        this.mapArea = area;

        setTimeout(() => {
            this.props.addFilter('mapLocation', area);
            // moderator for not calling server on each map movment
            setTimeout(() => {
                this.isMapMoving = false;
            },1000)
        }, 500)
    }

    addFilter(filter, value) {
        this.props.addFilter(filter, value)
    }

    openPinModal(pinData){
        this.setState({isFullscreen: !this.state.isFullscreen});

        if (!pinData) return;

        this.props.incPinViewCount(pinData._id);

        LocalStorageService.incVisitCount(pinData.category);

        // open ads count
        const analyticsCount = LocalStorageService.getVisitCount();
        let eventType = AnalyticsService.events.OPEN_PIN;

        if (pinData.category === 'openmic') {
            if (analyticsCount['openmic'] > AnalyticsService.consts.MIN_ADS_SHOW_COUNT) eventType = AnalyticsService.events.OPEN_PIN_OPENMIC_ABOVE;

        } else if (pinData.category === 'ooo') {
            if (analyticsCount['ooo'] > AnalyticsService.consts.MIN_ADS_SHOW_COUNT) eventType = AnalyticsService.events.OPEN_PIN_PLACES_TO_SHOW_ABOVE;

        } else if (pinData.type === LIVE_MUSIC) {
            if (analyticsCount[LIVE_MUSIC] > AnalyticsService.consts.MIN_ADS_SHOW_COUNT) eventType = AnalyticsService.events.OPEN_PIN_LIVE_MUSIC_ABOVE;
        }

        AnalyticsService.sendEvent(eventType, `${pinData.type}_${pinData.category}`, null, {
            pin_type: pinData.type,
            pin_category: pinData.category,
        });

        if (window && window.history && !isMobile()) {
            window.history.pushState('', '', `pages/${pinData._id}`);
            this.props.openPinFullViewModal(pinData);

            return;
        }

        browserHistory.push('/#');

        this.props.openPinFullViewModal(pinData);
    }

    openBandFinderPinModal(data){
        this.setState({isFullscreen: !this.state.isFullscreen});
        browserHistory.push('/#');
        this.props.openBandFinderPinModal(data);
    }

    handleZoomChange() {
        const currentZoom = this._map.getZoom();
        const mapData = this.props.datatypes.defaults;

        this.setState({
            width: mapData.dotSizesByZoom[currentZoom],
            height: mapData.dotSizesByZoom[currentZoom]
        })
    }

    getCategoryIcon(pinData, isGrouped) {
        if (!this.props.datatypes || !pinData.type) return '';

        if (isGrouped) return `${clientMedia()}/img/categoriesMarker/same-vanue.svg
        `
        if (pinData.type === BAND || pinData.type === MUSICIAN) {

            return `${clientMedia()}/img/categoriesMarker/${pinData.type}-marker-icon.svg`
        }

        const cat = this.props.datatypes.categories[pinData.type].filter(c => c.name === pinData.category);

        return cat && cat[0] && cat[0].images && cat[0].images[6].src
    }

    // TODO: needs to:
    // - open all the ads in the same address/ venue
    // - generate offset for each and one of them around the marker

    onMarkerClick(groupKey) {
        this.setState({isHoveringTooltip: false, showInfoKey: groupKey, isPinToolOpen: true});
    }

    onMarkerOut() {
        if (this.state.isHoveringTooltip) {
            this.setState({isHoveringMarker: false})
        }

        setTimeout(() => {
            this.setState({isHoveringMarker: false});
        }, 300)
    }

    onMarkerIn(index) {
        if (this.state.isPinToolOpen || this.state.isHoveringMarker || this.state.isHoveringTooltip) return;

        //this.setState({showInfoKey: index, isHoveringMarker: true})
    }

    getDotBigSize(subscription) {
        if (!subscription) return 0;

        if (subscription.enrolType === 'high' || subscription.enrolType === 'huge') {
            return MAP_MARKER_HIGH_PAID_SIZE;
        }

        return 0;

    }

    renderMarkerIdle(pinData) {
        if (!pinData) return;

        const mediaUrlPrefix = clientMedia();
        // make production and staging address
        if (pinData.type === LIVE_MUSIC) {
            return mediaUrlPrefix + '/img/mapIcons/live-music-marker.svg';
        }

        if (pinData.type === BAND) {
            return mediaUrlPrefix + '/img/mapIcons/band-marker.svg';
        }

        if (pinData.type === MUSICIAN) {
            return mediaUrlPrefix + '/img/mapIcons/musician-marker.svg';
        }

        // service
        return mediaUrlPrefix + '/img/mapIcons/service-marker.svg'
    }

    renderMarkerIcon(pinAddressGroup, gorupKey) {

        let isOnePaid;
        pinAddressGroup.forEach(p => {
            if (p.subscription.enrolType !== 'free' && p.subscription.enrolType !== 'mid') {
                isOnePaid = true
            }
        })

        const width = isOnePaid ? MAP_MARKER_HIGH_PAID_SIZE : 0; // this.getDotBigSize(pinData.subscription);
        const height = isOnePaid ? MAP_MARKER_HIGH_PAID_SIZE : 0; // this.getDotBigSize(pinData.subscription);


        if (this.state.showInfoKey === gorupKey && (this.state.isPinToolOpen || this.state.isHoveringMarker)) {
            return {
                url: this.getCategoryIcon(pinAddressGroup[0], pinAddressGroup.length > 1),
                size: {width: this.state.width + 30 + width, height: this.state.height + 30 + height},
                scaledSize: {width: this.state.width + 30 + width, height: this.state.height + 30 + height},
                optimized: true
            }
        }

        return {
            url: this.getCategoryIcon(pinAddressGroup[0], pinAddressGroup.length > 1) || this.renderMarkerIdle(pinAddressGroup[0]),
            size: {width: this.state.width + width, height: this.state.height + height},
            scaledSize: {width: this.state.width + width, height: this.state.height + height},
            optimized: true
        }
    }

    renderMarkerInfoWindow(pinAddressGroup, groupKey) {
        if (this.state.showInfoKey !== groupKey || !this.state.isPinToolOpen) return null;

        return (
            <InfoWindow>
                <PinToolTip
                    datatypes={this.props.datatypes}
                    openPinModal={this.openPinModal.bind(this)}
                    pinsList={pinAddressGroup}
                    isHovering={() => this.setState({isHoveringMarker: true})}
                    isNotHovering={() => {
                        if (this.state.isHoveringMarker) return;

                        setTimeout(() => {
                            this.setState({isHoveringMarker: false})
                        }, 10)
                    }}
                />
            </InfoWindow>
        )
    }

    renderMarker(pinAddressGroup, groupKey, index, pinSize) {
        if (!pinAddressGroup || pinAddressGroup.length < 1) return null;

        if (!pinAddressGroup[0].location.street && !pinAddressGroup[0].location.revenueName) return null;

        const { enrollType } = pinAddressGroup[0].subscription;

        return  (
            <Marker
                position={pinAddressGroup[0].location.position}
                anchor={pinAddressGroup[0].location.position}
                label={pinAddressGroup.length > 1 ? {
                    text: `${pinAddressGroup.length}`,
                    color: 'white'// pinAddressGroup[0].type === SERVICE ? '#250e47' : 'white'
                } : ''}
                key={`marker-${pinSize}-${index}`}
                onMouseover={() => this.onMarkerIn(groupKey)}
                onMouseout={() => this.onMarkerOut()}
                onClick={() => this.onMarkerClick(groupKey)}
                icon={this.renderMarkerIcon(pinAddressGroup, groupKey)}
                zIndex={this.state.showInfoKey === groupKey && this.state.isPinToolOpen ?
                    (enrollType === ENROL_TYPE_HIGH || enrollType === ENROL_TYPE_HUGE ? 99999 : 99998) :
                    (pinAddressGroup.length > 1 ? index + 2 : 1)
                }
            >

                {this.renderMarkerInfoWindow(pinAddressGroup, groupKey)}
            </Marker>
        );
    }

    renderPins() {
        // const smallPins = this.props.groupedPins.filter(p => p.subscription.enrolType !== 'high' && p.subscription.enrolType !== 'huge');
        return Object.keys(this.props.groupedPins || {}).map((groupKey, index) => {
            if (!this.props.groupedPins[groupKey] || this.props.groupedPins[groupKey].length < 1) return null;
            return this.renderMarker(this.props.groupedPins[groupKey], groupKey, index, 'small-pins');
        })
    }

    // TODO: not in use for now because of the grouping logic
    // renderBigPins() {
    //
    //     // const bigPins = this.props.groupedPins.filter(p => p.subscription.enrolType === 'high' || p.subscription.enrolType === 'huge');
    //     return Object.keys(this.props.groupedPins || {}).map((groupKey, index) => {
    //         if (!this.props.groupedPins[groupKey] || this.props.groupedPins[groupKey].length < 1) return null;
    //
    //         if (pinData.subscription.enrolType === 'high' || pinData.subscription.enrolType === 'huge') {
    //             return this.renderMarker(pinData, index, 'big-pins');
    //         }
    //
    //         return null;
    //     })
    // }

    renderMapComponent() {
        return (
            <this.MapComponent
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div className={`containerElements ${this.props.filters.type}`} />}
                mapElement={<div className="map-element" style={{ height: `100%` }} />}
            />
        )
    }

    setPinViewModals() {
        if (isMobile()) {
            return (
                <PinFullViewModalMobile
                    isModalOpen={this.props.isPinFullViewModalOpen}
                    closeModal={this.props.closePinFullViewModal}
                />
            )
        }

        return (
            <PinFullViewModalWeb
                isModalOpen={this.props.isPinFullViewModalOpen}
                closeModal={this.props.closePinFullViewModal}
                pin={this.props.pinFullViewData}
                datatypes={this.props.datatypes}
            />
        )
    }

    render() {
        if (!this.props.datatypes || !this.props.filters) return null;

        return (
            <div
                className={`mugicsMap ${this.props.filters.type}`}
                style={{display: isMobile() && this.props.mode !== "map" ? "none" : "block"}}
            >
                <MoneySlider
                    filters={this.props.filters}
                    onChange={this.addFilter.bind(this)}
                    datatypes={this.props.datatypes}
                />

                {isMobile() ?
                    <PinCounterLabel
                        type={this.props.filters.type}
                        defaults={this.props.datatypes.defaults || {}}
                        countryPinCount={this.props.countryPinCount || {}}
                    /> : null }

                {this.setPinViewModals()}

                {this.renderMapComponent(this.props.currentLocation)}

                {/*<GoogleMapLoader*/}
                {/*    containerElement={<div className={`containerElements ${this.props.filters.type}`} />}*/}
                {/*    googleMapElement={this.renderMapElement()}*/}
                {/*/>*/}
            </div>
        )
    }
}

MugicsMap.propTypes = {
    datatypes: PropTypes.object,
    currentLocation: PropTypes.object,
    filters: PropTypes.object,
    mode: PropTypes.oneOf(['map', 'list', 'gallery']),
    pinFullViewData: PropTypes.object,
    isPinFullViewModalOpen: PropTypes.bool,
    groupedPins: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    countryPinCount: PropTypes.object,

    // actions
    closePinFullViewModal: PropTypes.func,
    openPinFullViewModal: PropTypes.func,
    addFilter: PropTypes.func,
    openBandFinderPinModal: PropTypes.func,
    getPinsCall: PropTypes.func,
    incPinViewCount: PropTypes.func
}

const mapStateToProps = state => ({
    isModalOpen: state.main.isModalOpen,
    isNavModalOpen: state.main.isNavModalOpen,
    isBandFinderModalOpen: state.main.isBandFinderModalOpen,
    modalPinData: state.main.modalPinData,
    pinFullViewData: state.modals.pinFullViewData,
    datatypes: state.main.datatypes,
    route: state.routing.locationBeforeTransitions.pathname,
    isPinFullViewModalOpen: state.modals.isPinFullViewModalOpen,
    pagePins: state.main.pinsNew,
    countryPinCount: state.main.countryPinCount
})

// connecting the component to the actions in order to be able to dispatch them from the component
export const MugicsMapContainer = connect(mapStateToProps, {...actions, closePinFullViewModal, openPinFullViewModal})(MugicsMap);

export default MugicsMap;



// WEBPACK FOOTER //
// ./src/Components/Main/MugicsMap.js